// import OrderDetailInformation from "../Order/OrderDetailInformation";
import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
} from "react";
import { Formik, Form } from "formik";
// import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";
import Input_MeasurementSetting from "./../CustomedFields/Input_MeasurementSetting";
import CheckBox_MeasurementSetting from "./../CustomedFields/CheckBox_MeasurementSetting";
import ModalForForms from "../Modals/ModalForForms";
import MeasurementAttributeAdd from "../Measurement/MeasurementAttributeAdd";

import measurementSettingDetailSave from "../../Models/measurementSettingDetailSave";
// import roOrderDetailSave from "../../Models/roOrderDetailSave";
// import _measurementService from "./../../services/measurementServices";
import measurementSettingsDetailsServices from "./../../services/measurementSettingsDetailsServices";

// // React Notification
import { NotificationManager } from "react-notifications";
import { useSelector, useDispatch } from "react-redux";
import { update_MeasurementSettingDetails_forEdit } from "./../../slice/orderSlice";

// //** get actions from store */
// import { useSelector, useDispatch } from "react-redux";
// import {
//   clearOrderItemDetailStore,
//   addOrderItemDetailStore,
//   removeOrderItemDetailStore,
//   addOrderItemWithMeasurementsStore,
//   removeOrderItemWithMeasurementsStore,
//   addOrderItemUniqueStore,
//   removeOrderItemUniqueStore,
//   updateViewModeOrderItemDetailStore,
//   updateOrderDetailGUID_OrderItemDetailStore,
// } from "./../../slice/orderSlice";
// import { useTabIndex } from "react-tabindex";

const MeasurementSettingShow = (props) => {
  //Get state from store
  const { measurementSettingDetailForEdit } = useSelector(
    (state) => state.order
  );
  const dispatch = useDispatch();

  const tabIndexArray = [];
  var rowCounter = 0;
  var colCounter = 0;

  //********************************** Add Customer */
  const [measurementSettings_GUID, setMeasurementSettings_GUID] = useState("");
  const [
    measurementSettingsDetailsID_GUID,
    setMeasurementSettingsDetailsID_GUID,
  ] = useState("");

  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [titlePopup, settitlePopup] = useState("");
  const [showAddMeasurementSettingPopup, setShowAddMeasurementSettingPopup] =
    useState(false);
  const [isExtendedNote, setIsExtendedNote] = useState(false);
  const childSubmitButton = useRef(); // forwardRef(); // useRef(null);

  //NOTE: initial load is keeping commented,
  // as it's taking so much time to show data.
  const firstUpdate = useRef(true);

  useLayoutEffect(() => {
    //** Dont' run for First time */
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    settitlePopup(
      "Add Measurement Attribute( " + props.lstMeasurementDetail[0]?.name + " )"
    );
  });

  const AddMeasurementAttributePopup = (IsExtendedNote) => {
    setShowAddMeasurementSettingPopup(true);
    setIsUpdateMode(false);
    setMeasurementSettingsDetailsID_GUID("");
    setIsExtendedNote(IsExtendedNote);

    // ** set store value blank field
    dispatch(update_MeasurementSettingDetails_forEdit({}));
  };

  const UpdateMeasurementAttributePopup = (
    measurementSettingDetailsID_GUID
  ) => {
    alert(
      "measurementSettingDetailsID_GUID: " + measurementSettingDetailsID_GUID
    );
    setShowAddMeasurementSettingPopup(true);
    setIsUpdateMode(true);
    setMeasurementSettingsDetailsID_GUID(measurementSettingDetailsID_GUID);
  };
  // const onSubmit = (values) => {
  //   // alert("save it to DB from parent");
  //   console.log("values : " + values.Name);
  //   measurementSettingsDetailsServices.save(values);
  // };

  const SaveMeasurementSettingsToDB = async (values) => {
    console.log("Form data " + JSON.stringify(values));

    let objToSave = new measurementSettingDetailSave();
    objToSave.MeasurementSettingsID_GUID =
      props.selectedMeasurementSettingsID_GUID; // props.customerGUID;
    objToSave.MeasurementSettingsDetailID_GUID =
      measurementSettingsDetailsID_GUID;
    objToSave.IsNote = isExtendedNote; // props.selectedProductItemGUID; //
    // objToSave.FieldType = "";
    objToSave.innerObj = values;
    console.log("objToSave :" + objToSave);

    let result = await measurementSettingsDetailsServices.save(objToSave);
    //Update
    if (result != null) {
      // //(1)
      // setOrderDetailGUID_state(result.orderDetailID_GUID);
      // //(2)
      // dispatch(
      //   updateOrderDetailGUID_OrderItemDetailStore({
      //     indexNo: props.indexEntry,
      //     orderDetailID_GUID: result.orderDetailID_GUID,
      //   })
      // );

      //Notification
      NotificationManager.success(
        "Measurement Attribute Saved successfully",
        "Successful!",
        4000
      );
      console.log("result : " + JSON.stringify(result));
    } else {
      //Notification
      NotificationManager.warning(
        "Measurement Attribute Saved Failed",
        "Failed!",
        4000
      );
      console.log("result : " + JSON.stringify(result));
    }
  };

  const isValidChildFormInputs = (values) => {
    // alert("isValidChildFormInputs at parent");
    console.log("isValidChildFormInputs value : " + values);
  };

  const submitFromModalParent = () => {
    //alert("now submit child");
    childSubmitButton.current.click();
    //this.refs.childComponent.getWrappedInstance().handleSubmit();
  };

  //***  Edit OR Delete  ** */
  const delete_MeasurementSettingsDetails = (guid) => {
    // const concent = handleDeleteClick();
    confirmationOnDeleteClick()
      .then((concent) => {
        if (concent) {
          // alert("Delete -> delete_MeasurementSettingsDetails => guid: " + guid);
          props.delete_MeasurementSettingsDetailsByGUID(guid);
        }
      })
      .catch((error) => {
        console.error("Promise rejected:", error);
      });
  };

  const edit_measurementSettingsDetails = async (guid, isExtendedNote) => {
    alert(
      "Edit - edit_measurementSettingsDetails -> edit_MeasurementSettingsDetailsByGUID => guid: " +
        guid +
        ",..---" +
        isExtendedNote
    );

    //*** get from Database setting... */
    let measurementSettingDetail_GUID =
      await measurementSettingsDetailsServices.getByGUID(guid);

    if (measurementSettingDetail_GUID != null) {
      if (measurementSettingDetail_GUID.fieldType === 2) {
        measurementSettingDetail_GUID.fieldType = true;
      } else if (measurementSettingDetail_GUID.fieldType === 1) {
        measurementSettingDetail_GUID.fieldType = false;
      }
    }

    dispatch(
      update_MeasurementSettingDetails_forEdit(measurementSettingDetail_GUID)
    );

    // settitlePopup(
    //   ("Edit Measurement Attribute( " +
    //     props.lstMeasurementDetail[0]?.name +
    //     " )")
    // );
    settitlePopup(..."");
    setShowAddMeasurementSettingPopup(true);
    // setShowAddMeasurementSettingPopup(true);
    setIsUpdateMode(true);
    setMeasurementSettingsDetailsID_GUID(guid);

    // props.edit_MeasurementSettingsDetailsFunc(guid, isExtendedNote);
  };

  async function confirmationOnDeleteClick() {
    const confirmation = window.confirm(
      "Are you sure you want to remove this?"
    );
    return confirmation;
  }

  return (
    <Fragment>
      {/* ModalPopUp for customer add */}
      {showAddMeasurementSettingPopup && (
        <ModalForForms
          title={titlePopup} //"Add Measurement Attribute"
          setShowAddCustomerPopup={setShowAddMeasurementSettingPopup}
          submitFromModalParent={submitFromModalParent}
        >
          <MeasurementAttributeAdd
            isValidChildFormInputs={isValidChildFormInputs}
            AddMeasurementToDB={SaveMeasurementSettingsToDB}
            ref={childSubmitButton}
          />{" "}
        </ModalForForms>
      )}

      <div style={{ clear: "both" }}></div>

      <div className="media mb-4 mt-1">
        <div className="media-body">
          {/* <div
            className="ordermeasure-title"
            style={{ marginBottom: "10px", width: "400px" }}
          >
            <h6 className="m-0 text-primary">
              {props.lstMeasurementDetail[0]?.name}
              {" - "}Measurement Information:
            </h6>
            <div style={{ clear: "both" }}></div>
          </div> */}
          <div style={{ float: "left" }}>
            <h4 className="m-0 text-primary">
              {props.lstMeasurementDetail[0]?.name}
              {" - "}Measurement Information:
            </h4>
          </div>
          <div style={{ float: "right" }}>
            <button
              className="btn btn-primary px-3"
              onClick={() => AddMeasurementAttributePopup(false)}
            >
              Add New Attribute
            </button>
          </div>
          <div className="clearBoth"></div>
          <div style={{ clear: "both" }}></div>
          <hr />
          <div style={{ clear: "both" }}></div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body card-body-padding-less">
                  <div className="basic-list-group">
                    <Formik>
                      {(formik) => {
                        return (
                          <div>
                            {/* Comment : Note */}
                            <div style={{ clear: "both" }}></div>

                            {props.lstMeasurementDetail
                              .filter((measurementDetail) => {
                                return measurementDetail.isNote === false;
                              })
                              .map((item, index) => {
                                //Row
                                if ((index + 1) % 7 == 0) {
                                  return (
                                    <>
                                      <Input_MeasurementSetting
                                        label={item?.fieldName}
                                        delete_MeasurementSettingsDetailsByGUID={
                                          delete_MeasurementSettingsDetails
                                        }
                                        edit_measurementSettingsDetailsByGUID={
                                          edit_measurementSettingsDetails
                                        }
                                        isExtendedNote={false}
                                        guid={
                                          item.measurementSettingsDetailsID_GUID
                                        }
                                      />
                                      <div className="clearBoth"></div>,
                                    </>
                                  );
                                }

                                return (
                                  <>
                                    <Input_MeasurementSetting
                                      label={item?.fieldName}
                                      delete_MeasurementSettingsDetailsByGUID={
                                        delete_MeasurementSettingsDetails
                                      }
                                      edit_measurementSettingsDetailsByGUID={
                                        edit_measurementSettingsDetails
                                      }
                                      isExtendedNote={false}
                                      guid={
                                        item.measurementSettingsDetailsID_GUID
                                      }
                                    />
                                  </>
                                );
                              })}

                            <div style={{ clear: "both" }}></div>
                            {/* <div
                              style={{
                                marginTop: "5px",
                                fontWeight: "bold",
                              }}
                            >
                              Extended Note:
                            </div> */}
                            <div style={{ float: "left" }}>
                              <h4 className="m-0 text-primary">
                                Extended Note ee:
                              </h4>
                            </div>
                            <div style={{ float: "right" }}>
                              <button
                                className="btn btn-primary px-3"
                                onClick={() =>
                                  AddMeasurementAttributePopup(true)
                                }
                              >
                                Add New Extended Note
                              </button>
                            </div>
                            <div style={{ clear: "both" }}></div>
                            <hr />
                            <div style={{ clear: "both" }}></div>

                            {props.lstMeasurementDetail
                              .filter((measurementDetail) => {
                                return measurementDetail?.isNote === true;
                              })
                              .map((item, index) => {
                                if (item.fieldType === 1) {
                                  // text box
                                  // UpdateMeasurementAttributePopup
                                  return (
                                    <>
                                      <div
                                        style={{
                                          float: "left",
                                        }}
                                      >
                                        <Input_MeasurementSetting
                                          style={{
                                            width: "100%",
                                            marginRight: "30px",
                                          }}
                                          label={item?.fieldName}
                                          delete_MeasurementSettingsDetailsByGUID={
                                            delete_MeasurementSettingsDetails
                                          }
                                          edit_measurementSettingsDetailsByGUID={
                                            edit_measurementSettingsDetails
                                          }
                                          isExtendedNote={true}
                                          guid={
                                            item.measurementSettingsDetailsID_GUID
                                          }
                                          UpdateMeasurementAttributePopup={
                                            UpdateMeasurementAttributePopup
                                          }
                                        />
                                      </div>
                                    </>
                                  );
                                } else if (item?.fieldType === 2) {
                                  // Check box
                                  return (
                                    <>
                                      <div
                                        style={{
                                          float: "left",
                                        }}
                                      >
                                        <CheckBox_MeasurementSetting
                                          style={{
                                            width: "100%",
                                            marginRight: "30px",
                                          }}
                                          label={item?.fieldName}
                                          delete_MeasurementSettingsDetailsByGUID={
                                            delete_MeasurementSettingsDetails
                                          }
                                          edit_measurementSettingsDetailsByGUID={
                                            edit_measurementSettingsDetails
                                          }
                                          isExtendedNote={true}
                                          guid={
                                            item.measurementSettingsDetailsID_GUID
                                          }
                                          UpdateMeasurementAttributePopup={
                                            UpdateMeasurementAttributePopup
                                          }
                                        />
                                      </div>
                                    </>
                                  );
                                }
                              })}

                            <div
                              style={{
                                clear: "both",
                                marginTop: "5px",
                              }}
                            >
                              &nbsp;
                            </div>
                          </div>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MeasurementSettingShow;
